;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import clsx from 'clsx';
import { forwardRef } from 'react';
import { useController } from 'react-hook-form';
import type { FormInputProps, InputProps } from './types';
const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  placeholder,
  required,
  className,
  error,
  ...rest
}, ref) => {
  return <div className={clsx('flex w-full flex-col', className)}>
        {label && <label className="text-body-8 mb-3 font-semibold text-gray-600" htmlFor={rest.id}>
            {label}
            <span className="text-error-300">{required ? '*' : ''}</span>
          </label>}
        <input className={clsx('text-body-8 placeholder:text-body-8 w-full rounded-[.25rem] border p-3 placeholder:text-gray-400 focus:outline-hidden', {
      'border-error-300 focus:border-error-300': !!error,
      'focus:border-primary-500 border-gray-200': !error
    })} placeholder={placeholder} required={required} ref={ref} {...rest} />
        <div className="mt-1 h-4">
          {error && <p className="text-body-9 text-error-300 text-right">{error}</p>}
        </div>
      </div>;
});
Input.displayName = 'Input';
export const FormInput = ({
  name,
  error: errorProp,
  onChange: customOnChange,
  rules,
  ...rest
}: FormInputProps) => {
  const {
    field,
    fieldState: {
      error,
      isTouched
    }
  } = useController({
    name,
    rules
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (customOnChange) {
      customOnChange(e);
      // Also call field.onChange to update react-hook-form state
      field.onChange(e.target.value);
    } else {
      field.onChange(e);
    }
  };
  const shouldShowError = isTouched ? error?.message : undefined;
  return <Input {...field} {...rest} onChange={handleChange} error={errorProp ? errorProp : shouldShowError} data-sentry-element="Input" data-sentry-component="FormInput" data-sentry-source-file="index.tsx" />;
};
export default Input;